// prefs.ts — the capture page's remembered switches, kept in localStorage
// per browser. Today that is "Live splats" (§15.7 live mode, default on).
// Storage can be missing or throw (private mode, blocked site data), so every
// access is wrapped and falls back to the default.

export const LIVE_SPLATS_KEY = 'openscan.capture.liveSplats';

// StorageLike is the slice of Storage used here (tests pass a Map-backed one).
export interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

function browserStorage(): StorageLike | null {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage;
  } catch {
    return null;
  }
}

// loadLiveSplats: the stored "Live splats" choice, true unless switched off.
export function loadLiveSplats(storage: StorageLike | null = browserStorage()): boolean {
  try {
    return storage?.getItem(LIVE_SPLATS_KEY) !== '0';
  } catch (err) {
    console.debug('[openscan/prefs] could not read the Live splats preference; using on', err);
    return true;
  }
}

// saveLiveSplats remembers the choice (best effort).
export function saveLiveSplats(on: boolean, storage: StorageLike | null = browserStorage()): void {
  try {
    storage?.setItem(LIVE_SPLATS_KEY, on ? '1' : '0');
    console.info(`[openscan/prefs] Live splats ${on ? 'on' : 'off'}`);
  } catch (err) {
    console.debug('[openscan/prefs] could not store the Live splats preference', err);
  }
}
